 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"default~alert-details-alert-details-module~attendance-attendance-module~charges-charges-module~citie~4ac7e62d":"default~alert-details-alert-details-module~attendance-attendance-module~charges-charges-module~citie~4ac7e62d","common":"common","charges-charges-module":"charges-charges-module","generic-department-generic-department-module":"generic-department-generic-department-module","home-pass-home-pass-module":"home-pass-home-pass-module","product-condition-product-condition-module":"product-condition-product-condition-module","reasons-reasons-module":"reasons-reasons-module","reseller-list-reseller-list-module":"reseller-list-reseller-list-module","roles-roles-module":"roles-roles-module","default~alert-details-alert-details-module~attendance-attendance-module~cities-cities-module~collect~43495231":"default~alert-details-alert-details-module~attendance-attendance-module~cities-cities-module~collect~43495231","alert-details-alert-details-module":"alert-details-alert-details-module","missing-inv-history-missing-inv-history-module":"missing-inv-history-missing-inv-history-module","otp-details-otp-details-module":"otp-details-otp-details-module","default~attendance-attendance-module~cities-cities-module~collect-payment-collect-payment-module~col~e4a4ef89":"default~attendance-attendance-module~cities-cities-module~collect-payment-collect-payment-module~col~e4a4ef89","default~attendance-attendance-module~cities-cities-module~collect-payment-collect-payment-module~col~1bc1d6b4":"default~attendance-attendance-module~cities-cities-module~collect-payment-collect-payment-module~col~1bc1d6b4","attendance-attendance-module":"attendance-attendance-module","inventory-inventory-module":"inventory-inventory-module","layout-layout-module":"layout-layout-module","online-payments-online-payments-module":"online-payments-online-payments-module","recording-details-recording-details-module":"recording-details-recording-details-module","stock-inventory-stock-inventory-module":"stock-inventory-stock-inventory-module","tracking-tracking-module":"tracking-tracking-module","default~cities-cities-module~collect-payment-collect-payment-module~collection-dashboard-collection-~0b8df695":"default~cities-cities-module~collect-payment-collect-payment-module~collection-dashboard-collection-~0b8df695","default~cities-cities-module~collect-payment-collect-payment-module~collection-dashboard-collection-~aad5eb6a":"default~cities-cities-module~collect-payment-collect-payment-module~collection-dashboard-collection-~aad5eb6a","default~customer-assign-customer-assign-module~inventory-history-inventory-history-module":"default~customer-assign-customer-assign-module~inventory-history-inventory-history-module","default~cities-cities-module~collect-payment-collect-payment-module~collection-dashboard-collection-~81efa7a2":"default~cities-cities-module~collect-payment-collect-payment-module~collection-dashboard-collection-~81efa7a2","product-search-product-search-module":"product-search-product-search-module","default~cities-cities-module~collect-payment-collect-payment-module~collection-dashboard-collection-~f9d7ca10":"default~cities-cities-module~collect-payment-collect-payment-module~collection-dashboard-collection-~f9d7ca10","default~cities-cities-module~collect-payment-collect-payment-module~collection-dashboard-collection-~af3b3527":"default~cities-cities-module~collect-payment-collect-payment-module~collection-dashboard-collection-~af3b3527","default~cities-cities-module~collect-payment-collect-payment-module~collection-dashboard-collection-~89cbcf50":"default~cities-cities-module~collect-payment-collect-payment-module~collection-dashboard-collection-~89cbcf50","collect-payment-collect-payment-module":"collect-payment-collect-payment-module","ekyc-report-dashboard-ekyc-report-dashboard-module":"ekyc-report-dashboard-ekyc-report-dashboard-module","employee-dashboard-employee-dashboard-module":"employee-dashboard-employee-dashboard-module","escalation-master-escalation-master-module":"escalation-master-escalation-master-module","location-location-module":"location-location-module","default~cities-cities-module~collection-dashboard-collection-dashboard-module~company-company-module~53aae59f":"default~cities-cities-module~collection-dashboard-collection-dashboard-module~company-company-module~53aae59f","collection-dashboard-collection-dashboard-module":"collection-dashboard-collection-dashboard-module","crmdashboard-crmdashboard-module":"crmdashboard-crmdashboard-module","dashboard-dashboard-module":"dashboard-dashboard-module","ekyc-dashboard-ekyc-dashboard-module":"ekyc-dashboard-ekyc-dashboard-module","mobile-crmdashboard-mobile-crmdashboard-module":"mobile-crmdashboard-mobile-crmdashboard-module","task-dashboard-task-dashboard-module":"task-dashboard-task-dashboard-module","default~cities-cities-module~company-company-module~inventory-history-inventory-history-module~plans~f671b834":"default~cities-cities-module~company-company-module~inventory-history-inventory-history-module~plans~f671b834","services-services-module":"services-services-module","default~cities-cities-module~plans-plans-module":"default~cities-cities-module~plans-plans-module","cities-cities-module":"cities-cities-module","plans-plans-module":"plans-plans-module","default~crm-customer-dues-crm-customer-dues-module~productcategory-productcategory-module":"default~crm-customer-dues-crm-customer-dues-module~productcategory-productcategory-module","productcategory-productcategory-module":"productcategory-productcategory-module","default~crm-customer-dues-crm-customer-dues-module~crm-lead-crm-lead-module~custom-report-custom-rep~b6f65a61":"default~crm-customer-dues-crm-customer-dues-module~crm-lead-crm-lead-module~custom-report-custom-rep~b6f65a61","default~crm-customer-dues-crm-customer-dues-module~crm-lead-crm-lead-module~custom-report-custom-rep~91411766":"default~crm-customer-dues-crm-customer-dues-module~crm-lead-crm-lead-module~custom-report-custom-rep~91411766","default~customer-customer-module~generic-crm-generic-crm-module~inventory-history-inventory-history-~c0d4ddcb":"default~customer-customer-module~generic-crm-generic-crm-module~inventory-history-inventory-history-~c0d4ddcb","inventory-history-inventory-history-module":"inventory-history-inventory-history-module","crm-customer-dues-crm-customer-dues-module":"crm-customer-dues-crm-customer-dues-module","default~custom-report-custom-report-module~ekyc-payment-dashboard-ekyc-payment-dashboard-module":"default~custom-report-custom-report-module~ekyc-payment-dashboard-ekyc-payment-dashboard-module","ekyc-payment-dashboard-ekyc-payment-dashboard-module":"ekyc-payment-dashboard-ekyc-payment-dashboard-module","customer-customer-module":"customer-customer-module","replacement-new-replacement-new-module":"replacement-new-replacement-new-module","store-keeper-store-keeper-module":"store-keeper-store-keeper-module","team-assignment-team-assignment-module":"team-assignment-team-assignment-module","ekyc-post-charge-ekyc-post-charge-module":"ekyc-post-charge-ekyc-post-charge-module","location-master-location-master-module":"location-master-location-master-module","team-team-module":"team-team-module","users-users-module":"users-users-module","default~crm-lead-crm-lead-module~salesfunnel-salesfunnel-module":"default~crm-lead-crm-lead-module~salesfunnel-salesfunnel-module","crm-lead-crm-lead-module":"crm-lead-crm-lead-module","default~login-login-module~tasks-tasks-module":"default~login-login-module~tasks-tasks-module","tasks-tasks-module":"tasks-tasks-module","ekyc-post-payment-ekyc-post-payment-module":"ekyc-post-payment-ekyc-post-payment-module","generic-reason-generic-reason-module":"generic-reason-generic-reason-module","store-collection-store-collection-module":"store-collection-store-collection-module","default~distribution-distribution-module~report-report-module":"default~distribution-distribution-module~report-report-module","report-report-module":"report-report-module","login-login-module":"login-login-module","discount-rule-discount-rule-module":"discount-rule-discount-rule-module","company-company-module":"company-company-module","vendor-vendor-module":"vendor-vendor-module","pending-confirm-enq-pending-confirm-enq-module":"pending-confirm-enq-pending-confirm-enq-module"}[chunkId]||chunkId) + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
